module.exports = __webpack_public_path__ + "static/media/2024-website-hero.adcb2820.png";